import { mapActions, mapGetters, mapMutations } from 'vuex'
import dialogView from './dialog-view/index.vue'
import dialogDelete from './dialog-delete/index.vue'
import { debounce } from 'lodash'

export default {
  name: 'setting-education-categories',
  data () {
    return {
      page: 1,
      removingItem: null,
      openDialogDelete: false,
      filter: {
        keywords: '',
        status: '',
        countries: ''
      }
    }
  },
  components: {
    dialogView,
    dialogDelete
  },
  computed: {
    ...mapGetters({
      list: 'newsCategories/list',
      limit: 'newsCategories/limit',
      listLength: 'newsCategories/listLength',
      isLoading: 'newsCategories/isLoading',
      isListLoading: 'newsCategories/isListLoading',
      openDialogView: 'newsCategories/openDialogView',

      accessCountries: 'profile/accessCountries',
      countries: 'setting/countries',
      setting: 'news/setting'
    }),
    headers () {
      return [
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'Slug',
          value: 'slug'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions'
        }
      ]
    }
  },
  created () {
    this.fetchList(this.filter)
    this.setting || this.fetchSetting(this.filter)
  },
  methods: {
    ...mapActions({
      fetchList: 'newsCategories/GET_LIST',
      fetchSetting: 'news/GET_SETTING'
    }),
    ...mapMutations({
      changeSkip: 'newsCategories/CHANGE_SKIP',
      changeDialogView: 'newsCategories/CHANGE_DIALOG_VIEW',
      setList: 'newsCategories/SET_LIST',
      changeEditId: 'newsCategories/CHANGE_EDIT_ID'
    }),
    changePagination (index) {
      this.changeSkip(this.limit * (index - 1))
      this.$vuetify.goTo(0)
      this.fetchList(this.filter)
    },
    changeDialog (status = false, item = null) {
      this.changeEditId(item.id)
      this.changeDialogView(status)
    },
    changeDialogDeleteItem (item) {
      this.removingItem = item
      this.openDialogDelete = !this.openDialogDelete
    },
    sendRequest: debounce(function () {
      this.fetchList(this.filter)
    }, 1000)
  },
  destroyed () {
    this.setList([])
  }
}
